import { useState } from 'react';
import { HorizontalContainer, Attachment } from '@/components';
import { InlineFileViewer } from './InlineFileViewer';
import { cn } from '@/lib/cn';
import { FileEntity } from '@/shared/interfaces';

type AttachmentsListProps = {
    files: FileEntity[];
    className?: string;
    onRemoveCallback?: (identifier: string) => void;
    small?: boolean;
};

export const AttachmentsList = ({
    files,
    className,
    onRemoveCallback,
    small,
}: AttachmentsListProps) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    if (!files || files.length === 0) {
        return null;
    }

    const viewableFiles = files.filter((f) => f.guid);

    return (
        <>
            <HorizontalContainer
                className={cn('flex-wrap', className)}
                spacing="xs"
            >
                {files.map((fileEntity) => (
                    <Attachment
                        fileEntity={fileEntity}
                        key={fileEntity.identifier}
                        onRemoveCallback={onRemoveCallback}
                        onOpen={
                            fileEntity.guid
                                ? () => {
                                      const viewableIndex =
                                          viewableFiles.indexOf(fileEntity);
                                      setOpenIndex(viewableIndex);
                                  }
                                : undefined
                        }
                        small={small}
                    />
                ))}
            </HorizontalContainer>
            {openIndex !== null && viewableFiles.length > 0 && (
                <InlineFileViewer
                    files={viewableFiles}
                    currentIndex={openIndex}
                    onNavigate={setOpenIndex}
                    onClose={() => setOpenIndex(null)}
                />
            )}
        </>
    );
};
